/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

/**
 * Pagination for picture carousel component
 * @param {object} props
 * @param {number} props.numberOfPictures
 * @param {number} props.carouselIndex
 * @param {Function} props.setCarouselIndex
 * @param {React.MutableRefObject} props.actionSourceRef
 */
function CarouselPagination({
  numberOfPictures,
  carouselIndex,
  setCarouselIndex,
  actionSourceRef,
}) {
  return (
    <div className={styles['carousel-pagination']} data-testid="carousel-pagination">
      <button
        type="button"
        className={styles['carousel-pagination__chevron-button']}
        onClick={() => {
          if (carouselIndex > 0) {
            setCarouselIndex(carouselIndex - 1);
          } else {
            setCarouselIndex(numberOfPictures - 1);
          }
          actionSourceRef.current = 'click';
        }}
        aria-label="Previous image"
        data-testid="carousel-pagination__previous-btn"
      >
        <span className={classNames('icon', 'icon-chevron-left', styles['carousel-pagination__chevron-icon'])} />
      </button>
      <div
        className={styles['carousel-pagination__paging-dots']}
        data-testid="carousel-pagination__paging-dots"
      >
        {Array.from({ length: numberOfPictures }).map((_, i) => {
          const dotNumber = i + 1;
          const isCurrentPage = carouselIndex === i;

          return (
            <button
              type="button"
              aria-label={`Image ${dotNumber} of ${numberOfPictures}`}
              key={`${dotNumber}/${numberOfPictures}`}
              onClick={() => {
                setCarouselIndex(i);
                actionSourceRef.current = 'dot';
              }}
              data-testid="carousel-pagination__paging-dot"
              className={classNames(styles['carousel-pagination__paging-dot'], { [styles['carousel-pagination__paging-dot-current']]: isCurrentPage })}
            />
          );
        })}
      </div>
      <button
        type="button"
        className={styles['carousel-pagination__chevron-button']}
        onClick={() => {
          if (carouselIndex < numberOfPictures - 1) {
            setCarouselIndex(carouselIndex + 1);
          } else {
            setCarouselIndex(0);
          }
          actionSourceRef.current = 'click';
        }}
        aria-label="Next image"
        data-testid="carousel-pagination__next-btn"
      >
        <span className={classNames('icon', 'icon-chevron-right', styles['carousel-pagination__chevron-icon'])} />
      </button>
    </div>

  );
}

export { CarouselPagination };
